module.exports = __webpack_public_path__ + "img/SDG-11-EN.0e5a3361.png";